export default (dosage = {}) => {
  return Object.assign({
    'text': '',
    'timing': {
      'repeat': {
        'frequency': 1,
        'period': '',
        'periodUnit': '',
        'boundsDuration': {
          'code': '',
          'value': ''
        }
      }
    },
    'route': {
      'coding': [
        {
          'system': null,
          'code': '',
          'display': ''
        }
      ]
    },
    'doseAndRate': [
      {
        'doseQuantity': {
          'value': '',
          'unit': '',
          'system': null,
          'code': ''
        }
      }
    ]
  }, dosage);
};
